import {
  AuthProvider,
  getAuthClient,
  getToken,
  getUser,
  getDisplayNameForRole,
  transformUser,
  rolesEn,
  withAuth,
  useAuth as useSharedAuth,
} from '@verantos-dev/core-auth';
import { UserRolesIdsEnum } from '@verantos-dev/core-enums';

export {
  AuthProvider,
  getAuthClient,
  getToken,
  getUser,
  getDisplayNameForRole,
  transformUser,
  rolesEn,
  withAuth,
};

// The shared getUser derives isAdmin from SA_ADMIN, which annotation users never
// have, and has no isUser concept at all — so those two flags are derived here
// from the annotation-tool-specific roles instead.
export const useAuth = () => {
  const ctx = useSharedAuth();
  const roleIds = (ctx.user.roles ?? []).map(({ roleId }) => roleId);
  const isAdmin = roleIds.includes(UserRolesIdsEnum.ANNOTATION_MANAGER);
  const isUser = roleIds.includes(UserRolesIdsEnum.ANNOTATION_USER);

  return {
    ...ctx,
    user: {
      ...ctx.user,
      isAdmin,
      isUser,
    },
  };
};
